
import { WithStyles, withStyles } from "@material-ui/core/styles";
import * as React from "react";
import Component from "../../../components/Component";
import Page from "../../../components/Page";
import withAxios, { IAxiosProps } from "../../../components/withAxios";
import TextField from '@material-ui/core/TextField';
import { ISubscriptionPurchasePageProps } from "./../IAdminPageProps";
import LoadingSpinner from 'src/components/LoadingSpinner';
import { FormControl, InputLabel, MenuItem, Select, Button } from "@material-ui/core";

const styles = () => ({
  childTemplate: {
    paddingLeft: 80,
  },
  listItem: {
    "&:hover": {
      backgroundColor: "#e6e6e6",
    },
    backgroundColor: "white",
  },
});

type IProps = ISubscriptionPurchasePageProps &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface ITemplatesPageState {
  title: string;
  description: string;
  loader: boolean;
  price: string;
  payment_frequency_type: any;

}

export default withStyles(styles)(
  withAxios(
    class UpdateAddonPage extends Component<IProps, ITemplatesPageState> {
      public readonly state = this.buildState({
        title: "",
        description: '',
        loader: false,
        price: '',
        payment_frequency_type: ''
      });

      public componentDidMount(): void {

   if(Object.keys(this.props?.addonSelect).length>0){
    this.setState({
      title: this.props?.addonSelect?.title || "",
      description: this.props?.addonSelect?.description || "",
      price: this.props?.addonSelect?.price?.toString() || "",
      payment_frequency_type: this.props?.addonSelect?.payment_frequency_type || "",
    })
   }
      

      }


      public async updatePlanHandler() {
        this.setState({ loader: true })
        const res: any = await this.buildPut(
          this,
          `payment/updateAddonPlan/${this.props?.addonSelect?.id}`
        )({
          title: this.state.title,
          description: this.state.description,
          price: this.state.price,
          payment_frequency_type: this.state.payment_frequency_type,
        });
        this.setState({ loader: false })
        console.log("res====================?", res)
      }
      public render() {

        return (
          <>
            {this.state.loader &&<div className="loader-bg-color">
              <LoadingSpinner /></div>}
            <Page header="Subscription">
              <div>
                <div style={{ marginTop: 20 }}>
                  <Button variant="contained" color="primary" onClick={()=>{
                    this.updatePlanHandler()
                  }}>
                    Submit
                  </Button>
                </div>
                <div className="title-price">
                <div className="add-title" style={{ marginTop: 10 }}>
                  <TextField
                    label="Title"
                    variant="outlined" // You can change this to "filled" or "standard"
                    fullWidth={true} // This will make the input take the full width of the container
                    onChange={(e) => this.setState({ title: e.target.value })} // Handle the change event
                    value={this.state.title}
                  />
                </div>
               

                <div className="add-price" style={{ marginTop: 10 }}>
                  <TextField
                    label="Price"
                    variant="outlined" // You can change this to "filled" or "standard"
                    fullWidth={true} // This will make the input take the full width of the container
                    onChange={(e) => this.setState({ price: e.target.value })} // Handle the change event
                    value={this.state.price}
                  />
                </div>
                </div>
                <div style={{ marginTop: 20 }}>
                  <FormControl variant="outlined" fullWidth={true}>
                    <InputLabel id="dropdown-label">Choose an option</InputLabel>
                    <Select
                      labelId="dropdown-label"
                      value={this.state.payment_frequency_type}
                      onChange={(event) => {
                        this.setState({ payment_frequency_type: event.target.value })
                      }}
                      label="Select Payment Frequently"
                    >
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                      <MenuItem value={'free'}>Free</MenuItem>
                      <MenuItem value={'monthly'}>Monthly</MenuItem>
                      <MenuItem value={'yearly'}>Yearly</MenuItem>
                    </Select>
                  </FormControl>
                </div>
                <div style={{ marginTop: 10 }}>
                  <TextField
                    label="Description"
                    variant="outlined" // You can change this to "filled" or "standard"
                    fullWidth={true} // This will make the input take the full width of the container
                    onChange={(e) => this.setState({ description: e.target.value })} // Handle the change event
                    value={this.state.description}
                    multiline={true}
                    rows={4}
                  />
                </div>

                <div style={{ marginTop: 20 }}>
                  <Button variant="contained" color="primary" onClick={()=>{
                    this.updatePlanHandler()
                  }}>
                    Submit
                  </Button>
                </div>
              </div>
            </Page>
          
          </>
        );
      }



    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/admin/SubscriptionPurchaseList/updateAddon.tsx